<template>
  <div>
    <div class="c-input-label">Пол <span v-if="field.required" class="c-input-label__required">*</span></div>
    <c-switcher
      v-model="localValue"
      type="group"
      class="h-switcher"
      :items="[
        { icon: 'male', value: 1, tooltip: 'Мужской' },
        { icon: 'female', value: 2, tooltip: 'Женский' },
      ]"
    />

    <error-feedback v-if="error" :text="error" />
  </div>
</template>

<script>
import CSwitcher from "@/components/controls2/Switcher";
import ErrorFeedback from "@/components/error-feedback";

export default {
  components: { CSwitcher, ErrorFeedback },
  props: ["field", "value", "editable", "error"],
  data() {
    return {
      inited: false,
      localValue: null,
    };
  },

  watch: {
    localValue(v) {
      this.$emit("input", { value: v });
      if (this.inited) this.$emit("change");
    },
    value(v) {
      this.setData(v);
    },
  },

  created() {
    if (this.value) {
      this.setData(this.value);
    }
  },
  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;
      this.localValue = value.value;
      this.$nextTick(() => {
        this.inited = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

@include beforeBootstrapMd {
  .h-switcher {
    /deep/ {
      .c-switcher-group {
        width: 100%;
        &-item {
          flex-grow: 1;
        }
      }
    }
  }
}

.c-input-label {
  padding-top: 6px;
  display: flex;
}
</style>
